// 公共常量

// 当前项目的理由 BASE URL
export const ROUTER_BASE_URL = '/conference/2024-2/index/main';

// 当前生效的会议 code
export const ENABLED_CONFERENCE_CODE = '2024-second';

// 报名
export const REGISTRATION_URL_DESKTOP = 'https://openatomcon.openatom.cn/registration/?activityNo=HD20241128111206';
export const REGISTRATION_URL_MOBILE = 'https://openatomcon.openatom.cn/registration_mobile/?activityNo=HD20241128111206';
